import { useState, useEffect } from 'react'
import {
  Grid,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material'

import Dialog from './Dialog'
import InputField from './InputField'
import GridCheckbox from './GridCheckbox'
import GridIconButton from './GridIconButton'
import SortableTableHead from './SortableTableHead'
import { colours, titlesImpostazioni } from '../settings/settings'
import { formatBool as fB, formatBodyField } from '../hooks/utils-functions'
import {
  useGetCampionatiQuery,
  useCreateCampionatoMutation,
  useUpdateCampionatoMutation,
} from '../hooks/api-slice'

const columnsCampionati = [
  { label: 'Indice' },
  { label: 'Codice' },
  { label: 'Campionato' },
  { label: 'Stagione' },
  { label: 'Iscriz. aperte' },
  { label: 'Gironi pubbl.' },
  { label: 'Calend. pubbl.' },
  { label: 'Fine spost. gratis' },
  { label: 'Fine gironi' },
  { label: 'Chiuso' },
  { label: '' },
]

const DialogCampionati = ({ open, handleClose }) => {
  const { data: campionati } = useGetCampionatiQuery()
  const [createCampionatoMutation] = useCreateCampionatoMutation()
  const [updateCampionatoMutation] = useUpdateCampionatoMutation()

  const [editingItem, setEditingItem] = useState()
  const [addingItem, setAddingItem] = useState()
  const [newCampionato, setNewCampionato] = useState()

  const cSetNewCampionato = (field, value) =>
    setNewCampionato({ ...newCampionato, [field]: formatBodyField(value) })

  const clearNewItem = () => {
    setEditingItem()
    setAddingItem()
    setNewCampionato()
  }

  useEffect(() => {
    clearNewItem()
  }, [open])

  const addNewItem = async () => {
    const result = await createCampionatoMutation(newCampionato)
    if (!result?.error) clearNewItem()
  }

  const editItem = async id => {
    const result = await updateCampionatoMutation({ id, ...newCampionato })
    if (!result?.error) clearNewItem()
  }

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      title={titlesImpostazioni.titleCampionati}
      stretchWidth
      stretchHeight
    >
      {!campionati ? (
        <h4>Campionati non trovati.</h4>
      ) : (
        <Grid container spacing={2} sx={{ width: '100%' }}>
          <Grid container alignItems='center' sx={{ width: '100%' }}>
            {(addingItem && (
              <>
                <Grid size={{ xs: 4, md: 2 }}>
                  <center>
                    <InputField
                      id='indice'
                      label={columnsCampionati?.[0]?.label}
                      value={newCampionato?.indice}
                      onChange={i => cSetNewCampionato('indice', i)}
                      autoFocus
                      type='number'
                    />
                  </center>
                </Grid>
                <Grid size={{ xs: 8, md: 3 }}>
                  <center>
                    <InputField
                      id='codice'
                      label={columnsCampionati?.[1]?.label}
                      value={newCampionato?.codice}
                      onChange={i => cSetNewCampionato('codice', i)}
                    />
                  </center>
                </Grid>
                <Grid size={{ xs: 12, md: 3 }}>
                  <center>
                    <InputField
                      id='nome'
                      label={columnsCampionati?.[2]?.label}
                      value={newCampionato?.nome}
                      onChange={i => cSetNewCampionato('nome', i)}
                    />
                  </center>
                </Grid>
                <Grid size={{ xs: 8, md: 2 }}>
                  <center>
                    <InputField
                      id='stagione'
                      label={columnsCampionati?.[3]?.label}
                      value={newCampionato?.stagione}
                      onChange={i => cSetNewCampionato('stagione', i)}
                    />
                  </center>
                </Grid>
                <GridIconButton
                  type='save'
                  size={{ xs: 2, md: 1 }}
                  onClick={addNewItem}
                />
                <GridIconButton
                  type='clear'
                  size={{ xs: 2, md: 1 }}
                  onClick={() => {
                    setAddingItem()
                    clearNewItem()
                  }}
                />
              </>
            )) || (
              <GridIconButton
                type='add'
                size={12}
                onClick={() => {
                  setEditingItem()
                  setAddingItem(true)
                  setNewCampionato({})
                }}
                text='Nuovo campionato'
              />
            )}
          </Grid>
          {(campionati.length === 0 && <h4>Nessun campionato trovato.</h4>) || (
            <TableContainer component={Paper}>
              <Table size='small'>
                <SortableTableHead
                  table={campionati}
                  columns={columnsCampionati}
                />
                <TableBody>
                  {campionati.map((c, index) => {
                    const TableCellCheckbox = ({ field }) => (
                      <TableCell>
                        <GridCheckbox
                          value={!!newCampionato?.[field]}
                          onChange={(_, x) => cSetNewCampionato(field, x)}
                          md={12}
                        />
                      </TableCell>
                    )

                    return (
                      <TableRow
                        key={index}
                        style={{ backgroundColor: colours.white }}
                      >
                        {(editingItem && newCampionato?.codice === c.codice && (
                          <>
                            <TableCell>
                              <InputField
                                id='indice'
                                value={newCampionato?.indice}
                                onChange={i => cSetNewCampionato('indice', i)}
                                mode='update'
                                type='number'
                              />
                            </TableCell>
                            <TableCell>{c.codice}</TableCell>
                            <TableCell>
                              <InputField
                                id='nome'
                                value={newCampionato?.nome}
                                onChange={i => cSetNewCampionato('nome', i)}
                                mode='update'
                              />
                            </TableCell>
                            <TableCell>
                              <InputField
                                id='stagione'
                                value={newCampionato?.stagione}
                                onChange={i => cSetNewCampionato('stagione', i)}
                                mode='update'
                              />
                            </TableCell>
                            <TableCellCheckbox field='iscrizioniAperte' />
                            <TableCellCheckbox field='gironiPubblicati' />
                            <TableCellCheckbox field='calendariPubblicati' />
                            <TableCell>
                              <InputField
                                id='termineSpostamentiGratuiti'
                                value={
                                  newCampionato?.termineSpostamentiGratuiti
                                }
                                onChange={i =>
                                  cSetNewCampionato(
                                    'termineSpostamentiGratuiti',
                                    i,
                                  )
                                }
                                mode='update'
                              />
                            </TableCell>
                            <TableCell>
                              <InputField
                                id='termineGironi'
                                value={newCampionato?.termineGironi}
                                onChange={i =>
                                  cSetNewCampionato('termineGironi', i)
                                }
                                mode='update'
                              />
                            </TableCell>
                            <TableCellCheckbox field='campionatoChiuso' />
                            <TableCell>
                              <Grid
                                container
                                spacing={2}
                                sx={{ width: '100%' }}
                              >
                                <GridIconButton
                                  type='save'
                                  onClick={() => editItem(c._id)}
                                />
                                <GridIconButton
                                  type='clear'
                                  onClick={() => {
                                    setEditingItem(false)
                                    clearNewItem()
                                  }}
                                />
                              </Grid>
                            </TableCell>
                          </>
                        )) || (
                          <>
                            <TableCell>{c.indice}</TableCell>
                            <TableCell>{c.codice}</TableCell>
                            <TableCell>{c.nome}</TableCell>
                            <TableCell>{c.stagione}</TableCell>
                            <TableCell>{fB(c.iscrizioniAperte)}</TableCell>
                            <TableCell>{fB(c.gironiPubblicati)}</TableCell>
                            <TableCell>{fB(c.calendariPubblicati)}</TableCell>
                            <TableCell>
                              {c?.termineSpostamentiGratuiti}
                            </TableCell>
                            <TableCell>{c?.termineGironi}</TableCell>
                            <TableCell>{fB(c.campionatoChiuso)}</TableCell>
                            <TableCell>
                              <center>
                                <GridIconButton
                                  type='edit'
                                  onClick={() => {
                                    setEditingItem(true)
                                    setAddingItem()
                                    setNewCampionato(c)
                                  }}
                                />
                              </center>
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Grid>
      )}
    </Dialog>
  )
}

export default DialogCampionati
